<template>
  <a-modal v-model="visible" title="确认租约" :width="600" @cancel="close">
    <a-descriptions title="租客信息" :column="2">
      <a-descriptions-item label="姓名">{{
        formData.realName
      }}</a-descriptions-item>
      <a-descriptions-item label="性别">{{ formData.sex }}</a-descriptions-item>
      <a-descriptions-item label="联系方式">{{
        formData.mobile
      }}</a-descriptions-item>
      <a-descriptions-item label="证件号">{{
        formData.idCardNo
      }}</a-descriptions-item>
    </a-descriptions>
    <a-descriptions :title="formData.houseName" :column="2">
      <a-descriptions-item label="房间类型">{{
        formData.rentTypeName
      }}</a-descriptions-item>
      <a-descriptions-item label="房间号">{{
        formData.no
      }}</a-descriptions-item>
      <a-descriptions-item label="付款周期">{{
        paramData.payCycle
      }}</a-descriptions-item>
      <a-descriptions-item label="付款方式">
        <a-select
          style="width: 150px"
          v-model="paramData.payWay"
          @change="handleChange"
        >
          <a-select-option
            v-for="item in payWayList"
            :value="item.dictCode"
            :key="item.dictCode"
            >{{ item.dictName }}</a-select-option
          >
        </a-select>
      </a-descriptions-item>
      <a-descriptions-item label="月租金"
        ><a-input v-model="paramData.monthRent" suffix="元"></a-input
      ></a-descriptions-item>
      <a-descriptions-item label="押金"
        ><a-input v-model="paramData.deposit" suffix="元"></a-input
      ></a-descriptions-item>
      <a-descriptions-item label="租约开始日期"
        ><a-date-picker
          @change="dateChange"
          :format="dateFormat"
          v-model="paramData.startTime"
      /></a-descriptions-item>
      <a-descriptions-item label="下次交租日期">{{
        paramData.nextTime
      }}</a-descriptions-item>
      <a-descriptions-item label="租约结束日期" :span="2"
        ><a-date-picker :format="dateFormat" v-model="paramData.finishTime"
      /></a-descriptions-item>
      <a-descriptions-item label="补充条款" :span="2">
        <div style="width: 450px;">
          <a-input
            style="width: 100%;"
            v-model="paramData.terms"
            :rows="4"
            type="textarea"
            :maxLength="200"
            placeholder="请输入补充条款"
          />
        </div>
      </a-descriptions-item>
    </a-descriptions>
    <template slot="footer">
      <a-button
        type="primary"
        @click="cancel"
        :loading="cancelLoading"
        :disabled="confirmLoading"
        >取消租约</a-button
      >
      <a-button
        type="primary"
        :loading="confirmLoading"
        :disabled="cancelLoading"
        @click="ok"
        >确认租约</a-button
      >
      <a-button @click="close">关闭</a-button>
    </template>
  </a-modal>
</template>
<script>
import moment from "moment";
import cloneDeep from "lodash.clonedeep";
import { monthFormat, formatting } from "../../../../utils/util.js";
export default {
  name: "EditLeaseForm",
  data() {
    return {
      dateFormat: "YYYY-MM-DD",
      visible: false,
      formData: {},
      paramData: {
        leaseNo: "",
        payCycle: "",
        monthRent: 0, //月租金
        deposit: 0, //押金
        payWay: "",
        payWayName: "",
        month: "",
        startTime: "",
        finishTime: "",
        nextTime: "",
        terms: ""
      },
      userInfo: {},
      payWayList: [],
      confirmLoading: false, //确认
      cancelLoading: false //取消
    };
  },
  methods: {
    show(data) {
      this.userInfo = this.$store.getters.userInfo;
      this.visible = true;
      this.formData = data;
      this.paramData.leaseNo = this.formData.leaseNo;
      this.paramData.startTime = moment(
        this.formData.startTime.substring(0, 10),
        this.dateFormat
      );
      this.paramData.finishTime = moment(
        this.formData.finishTime.substring(0, 10),
        this.dateFormat
      );
      this.paramData.nextTime = this.formData.nextTime;
      this.paramData.month = this.formData.month;
      this.paramData.monthRent = this.formData.monthRent;
      this.paramData.deposit = this.formData.deposit;
      this.paramData.payCycle = monthFormat(this.formData.month);
      this.paramData.payWay = this.formData.payWay;
      this.getBaseInfo();
    },
    ok() {
      if (!this.confirmLoading) {
        this.confirmLoading = true;
        const param = cloneDeep(this.paramData);
        let start = this.paramData.startTime.format(this.dateFormat);
        let end = this.paramData.finishTime.format(this.dateFormat);
        param.startTime = start + " 00:00:00";
        param.finishTime = end + " 23:59:59";
        param.nextTime = this.paramData.nextTime + " 23:59:59";
        param.checkSta = this.userInfo.userType == "2" ? "C" : "S";
        param.businessType = "sure";
        delete param.payCycle;
        this.$http.roomBksApi.modifyHouseUserLease(param).then(res => {
          this.confirmLoading = false;
          if (res.result == 0) {
            // window.open(res.resultObject.partAsignUrl, "_blank");
            this.$message.success("租约确认成功");
            this.close();
            this.$emit("success");
          }
        });
      }
    },
    close() {
      this.visible = false;
      this.confirmLoading = false;
      this.cancelLoading = false;
    },
    cancel() {
      if (!this.cancelLoading) {
        this.cancelLoading = true;
        let param = {};
        param.leaseNo = this.formData.leaseNo;
        param.sta = "X"; //取消租约
        param.checkSta = this.userInfo.userType == "2" ? "C" : "S";
        param.businessType = "cancel";
        this.$http.roomBksApi.modifyHouseUserLease(param).then(res => {
          this.cancelLoading = false;
          if (res.result == 0) {
            this.$message.success("租约取消成功");
            this.close();
            this.$emit("success");
          }
        });
      }
    },
    async getBaseInfo() {
      this.$http.roomBksApi.findHouseKindData().then(res => {
        if (res.result == 0) {
          this.payWayList = res.resultObject.payWayList;
          this.getPayWay(this.paramData.payWay);
        }
      });
    },

    dateChange(value) {
      this.computeNextTime(value.toDate());
    },
    computeNextTime(value) {
      if (value) {
        let m = 0;
        if (this.paramData.month == 1) {
          m = 1;
        } else {
          m = this.paramData.month - 1;
        }
        value.setMonth(value.getMonth() + parseInt(m));
        this.paramData.nextTime = formatting(value);
      }
    },
    handleChange(selectItem) {
      let args = this.getPayWay(selectItem);
      let arr = args.split(",");
      if (arr && arr.length > 1) {
        let month = arr[1];
        this.paramData.month = month;
        let multiple = arr[0];
        this.paramData.deposit =
          parseInt(multiple) * parseInt(this.paramData.monthRent);
        this.paramData.payCycle = monthFormat(month);
        this.computeNextTime(this.paramData.startTime.toDate());
      }
    },
    getPayWay(value) {
      let args = "";
      for (let item of this.payWayList) {
        if (item.dictCode == value) {
          this.paramData.payWayName = item.dictName;
          args = item.args;
          break;
        }
      }
      return args;
    }
  }
};
</script>

<style lang="less" scoped>
/deep/ .ant-descriptions-item-label {
  min-width: 75px;
  text-align: right;
}
</style>
